import * as $ from 'jquery';

export const nav = () => {
    console.log('nav loaded');
    
    $("#mobile-trigger").click(function(){
        $(".mobile-nav").removeClass("slideOutRight");
        $(".mobile-nav").show();
        $(".mobile-nav").addClass("slideInRight");
        $('body').css('overflow-y','hidden')
        $('body').css('position','fixed')
    });
    $("#mobile-nav-close").click(function(){
        $(".mobile-nav").removeClass("slideInRight");
        $(".mobile-nav").addClass("slideOutRight");
        $('body').css('overflow-y','inherit')
        $('body').css('position','inherit')
    }); 

};
